import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelSelect/ModelSelect.styled.ts",
    _templateObject,
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { ListItemIcon, ListItemText, ListItem as ListItemMiu, Popover as PopoverMiu } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import styled from 'styled-components';
import { ArrowDown as ArrowDownInit } from '@gmini/ui-kit';
export var IconWrap = withStyles({
  root: {
    marginRight: '4px'
  }
})(ListItemIcon);
export var ListItemTextNoWrap = withStyles({
  primary: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    fontSize: '12px',
    letterSpacing: '0.15px',
    fontWeight: 'bold',
    lineHeight: '12px'
  }
})(ListItemText);
export var CubeWithTargetWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 24px;\n  margin-right: 7px;\n  margin-left: 5px;\n"])));
export var ListItemSelect = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  cursor: ", ";\n  padding: 4px 52px 4px 16px;\n  transition: 0.2s ease-out background-color;\n  user-select: none;\n  opacity: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.disabled ? 0.7 : 1;
}, function (props) {
  return props.disabled ? 'inherit' : 'rgba(0, 0, 0, 0.04)';
});
export var ArrowDown = styled(ArrowDownInit)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: auto;\n\n  & path {\n    ", "\n  }\n"])), function (props) {
  return props.selected && 'fill: #E1E1E9 !important;';
});
export var ArrowDownWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 6px;\n  border-radius: 50%;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: ", ";\n\n  ", "\n"])), function (props) {
  return props.highlight && !props.selected ? 'rgba(125, 177, 255, 0.5)' : 'inherit';
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.disabled && 'opacity: 0.5; pointer-events: none;';
});
export var ListItem = styled(ListItemMiu)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border-radius: 4px;\n  height: 28px;\n  position: relative;\n  font-weight: bold;\n  font-size: 12px;\n  letter-spacing: 0.15px;\n  color: ", ";\n  background: ", ";\n  ", "\n\n  &:hover {\n    background: rgba(53, 59, 96, 0.1);\n    color: #00003d;\n  }\n"])), function (props) {
  return props.selected ? '#E1E1E9' : '#353B60';
}, function (props) {
  return props.selected ? '#353B60 !important' : 'inherit';
}, function (props) {
  return !props.selected && ' z-index: 1;';
});
export var Popover = withStyles({
  paper: {
    left: '2px !important',
    boxShadow: '0px 5px 10px rgba(53, 60, 96, 0.15)',
    borderRadius: '4px'
  }
})(PopoverMiu);